import React from 'react';
import PropTypes from 'prop-types';

import CCSAccordion from '@ey/canvascoreservices/Accordion';

const Accordion = ({...rest}) => <CCSAccordion {...rest} />;

Accordion.propTypes = {};

export default Accordion;
